var _metadata, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M238.6,478.2h156.7v36.7H238.6V478.2L238.6,478.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M238.6,579h156.7v36.8H238.6V579z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M238.6,682.9h156.7v36.8H238.6V682.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M238.6,786.9h156.7v36.8H238.6V786.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M508.8,278.3h250.5v36.8H508.8V278.3L508.8,278.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M508.8,399.2h250.5v36.8H508.8V399.2L508.8,399.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M508.8,520h250.5v36.8H508.8V520L508.8,520z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M835.5,894.7v-753H683.1V68.6H432.7v73.1v36.8v118.9H212.6v73h-48v524.3H10v36.8h154.6h268.1h36.8h78.7h162h125.4H990v-36.8H835.5z M469.5,105.3h176.9v36.3H469.5V105.3z M249.3,334h176.9v36.3H249.3V334z M201.3,894.7V407.1h11.3h220.1v487.6H201.3z M584.9,894.7V785.3h88.5v109.4H584.9z M710.1,894.7V748.6h-162v146.1h-78.7V370.3V178.4h213.6h115.6v716.3H710.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/Company.721a5182.svg";
export { ForwardRef as ReactComponent };